










































































































import { Trustpilot } from '@front/common/components'
import { isMobile } from '@front/common/mixins'
import { Animation, Slider, Typography, TYPOGRAPHY_TYPES } from '@front/ui'
import {
  ANIMATION_DURATION,
  TITLE_UP,
  BLOCK_IN,
} from '@front/ui/Animation/animations'
import { defineComponent } from 'vue-demi'

import CircleProgress from './components/CircleProgress'
import InlineVideo from './components/InlineVideo.vue'

export default defineComponent({
  components: {
    InlineVideo,
    Typography,
    Slider,
    CircleProgress,
    Trustpilot,
    Animation,
  },
  mixins: [isMobile],
  setup() {
    const testimonials = [
      {
        videoUrl:
          'https://japhy-assets.twic.pics/video/uc?id=1qJD3Q6G2wrUpNWdnwK3ZV9lBrrSXSZAy&export=download',
        // registeredDate: '21 avril',
        breedName: 'Spitz',
        name: 'George et Vicky',
        special: 'Fan de poulet - adore grignoter nos cartons',
      },
      {
        videoUrl:
          'https://japhy-assets.twic.pics/video/uc?id=1qMd0fmtloUR_TXdwr3mkXOOvUVX3tNpU&export=download',
        // registeredDate: '21 avril',
        breedName: 'Golden retriever',
        name: 'Meggie et Waffle',
        special: 'Gourmand comme tout - adore les balles Japhy',
      },
      {
        videoUrl:
          'https://japhy-assets.twic.pics/video/uc?id=1qKQbOn_8du8Yd8XvqxfcPdmLpr7ZrY7T&export=download',
        // registeredDate: '21 avril',
        breedName: 'Teckel à poil cours',
        name: 'Anaïs et Sésame',
        special: 'Adore notre terrine au boeuf - saute très haut !',
      },
      {
        videoUrl:
          'https://japhy-assets.twic.pics/video/uc?id=1qF4uAOwqEPD5Simykvb-WB81wyIY21SG&export=download',
        // registeredDate: '21 avril',
        breedName: 'Golden Retriever',
        name: 'Léa et Vera',
        special: 'Adore le poulet - gourmand',
      },
      {
        videoUrl:
          'https://japhy-assets.twic.pics/video/uc?id=1ptDa0wjvSFdRNvwva1VVrUTtXwJX0pXu&export=download',
        // registeredDate: '21 avril',
        breedName: 'Chat européen',
        name: 'François et Ninours',
        special: 'Adore le poisson - passionné des oiseaux',
      },
    ]

    return {
      TYPOGRAPHY_TYPES,
      testimonials,
      TITLE_UP,
      ANIMATION_DURATION,
      BLOCK_IN,
    }
  },
})
